import { http } from '@/http/axios.js'

// 列表
export function getListAPI(params) {
    return http({
        url: `/api/manage/finance/order/page`,
        method: 'get',
        params
    })
}